module.exports = __webpack_public_path__ + "img/latte.8a2b9e76.png";